import script from "./simple.vue?vue&type=script&setup=true&lang=ts"
export * from "./simple.vue?vue&type=script&setup=true&lang=ts"

import "./simple.vue?vue&type=style&index=0&id=79bc4aca&lang=css"

const __exports__ = script;

export default __exports__